import { createFileRoute } from '@tanstack/react-router';
import { WarehouseCreateRouteView } from '@/pages/workspaces/integrations/warehouse/routing';
import { LastWorkspaceResolver } from './-components';

function WarehouseCreateRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <WarehouseCreateRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync')({
  component: WarehouseCreateRoute,
});
